import React, { createContext, ReactNode, useEffect } from 'react'
import { LoginParamsBo, LoginBo } from '@src/domain/services/auth.services'
import { LocalService, AuthService } from '@src/domain/services'
import { useMutation } from '@src/hooks'
import { userActions, useDispatch, useSelector } from '@src/store'
import { axios } from '@src/lib/axios'

export interface AuthContextType {
  isAuthenticated: boolean;
  login: (params: LoginParamsBo) => Promise<LoginBo>;
  logout: () => void;
  userInfo: LoginBo | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { userInfo } = useSelector(state => state.user)
  const dispatch = useDispatch()

  const { mutate: loginFn } = useMutation(AuthService.login)

  const isAuthenticated = !!LocalService.getToken()

  useEffect(() => {
    const token = LocalService.getToken()
    if (token) {
      axios.defaults.headers.Authorization = `Bearer ${token}`
      // TODO: 用token取得userInfo
    }
  }, [])

  const login = async ({ account, password }: LoginParamsBo): Promise<LoginBo> => {
    const userInfo = await loginFn({ account, password })
    // 設定 token
    LocalService.setToken(userInfo.accessToken)

    return userInfo
  }

  const logout = () => {
    LocalService.removeToken()
    dispatch(userActions.setUserInfo(null))
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, userInfo, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
